import * as React from 'react'
// libs
import styled from 'styled-components'
import { Helmet } from 'react-helmet-async'
import { useRouter } from 'hooks/useRouter'
import { matchPath } from 'react-router'
// components
import MainLayoutContainer from 'containers/MainLayout/index'
import { Container as ContainerOrigin } from '@mui/material'
import { EnterFullScreenButton, ExitReportButton, ExportReportButton } from 'components/CTAs/index'
// hooks
import { useSetPowerBIToken } from 'hooks/index'
// themes
import { colors } from 'themes'

// styled
const Container = styled(ContainerOrigin)`
  && {
    padding: 0;

    iframe {
      background-color: ${colors.white};
      height: calc(100vh - 64px) !important;
    }
  }
`

const PowerBIReport = React.lazy(() => import('components/PageComponents/DataHub/Report/PowerBIReport'))

const Report: React.FC = () => {
  const router = useRouter()

  const token = useSetPowerBIToken({ reportId: router.query.id, workspaceId: router.query.workspaceId, isEdit: true })

  const isEdit = !!matchPath('/data-hub/report/edit/:id/workspace/:workspaceId/name/:name', router.pathname)

  return (
    <>
      <Helmet>
        <title>{`Skefto - ${isEdit ? 'Report Edit' : 'Report'}`}</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={!token}
        label={router.query.name}
        CTA={
          <>
            {/*<ExportReportButton />*/}
            <EnterFullScreenButton />
            <ExitReportButton />
          </>
        }>
        <Container maxWidth={false}>
          <React.Suspense fallback={null}>
            <PowerBIReport token={token} />
          </React.Suspense>
        </Container>
      </MainLayoutContainer>
    </>
  )
}

export default Report
